import { httpRequest } from "../../http";

export class CommandUnlinkAds {
  async run(organizationId: number, folderId: number, adId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/${organizationId}/folders/${folderId}/ads/${adId}/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "DELETE",
      });
      return response;
    } catch (error) {
      console.error("Error unlinking ads:", error);
      throw error;
    }
  }
}
